/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/warenkorb.ts.
 */
import {WarenkorbEntry} from './warenkorb-entry';
import {User} from './user';
import {Lieferkunde} from './lieferkunde';

/**
 * Zweck: Beschreibt class Warenkorb und ihren Daten- oder Funktionsvertrag.
 */
export class Warenkorb {
  id: any;
  label: string;

  addNoteToOrderConfirmation: boolean;
  warenguthabenauftrag: boolean;
  note: string;
  entries: WarenkorbEntry[];
  shared: boolean;
  readonly_impersonation_workspace: boolean;
  locked: boolean;
  agbaccepted: boolean;
  artikel_count: number;
  wert_summe: number;
  owner: boolean;
  owner_user: User;
  autosend_imp: boolean;
  lieferkunde_nr: string;
  lieferkunde: Lieferkunde;
  defect: boolean;
  reTage: number;
  valutaDate: string;
  liefernAb: string;
  externeKopfreferenz: string;
  sortierkennzeichen: string;

  supplierId: string;
  supplierLabel: string;
}
